export const VALUES_FIELD_NAME = [
    'Cascaded',
    'Hamburger style',
    'Keypad style',
    'List menu',
    'Outdoor map',
] as const;
export type TYPES_FIELD_NAME = typeof VALUES_FIELD_NAME[number];
